export default class ApiInterface {
	constructor(apiKey) {
		this.endpoint = 'https://peoplemaps.us/mapsdata';
		// this.endpoint = 'http://localhost:8000'
		this.token = apiKey;
	}

  // the function to make the GET api call for fetching the data.
	call(apiEndpoint, data, callback) {
		let url = "";
		apiEndpoint = this.endpoint + "/" + apiEndpoint;

		Object.keys(data).map(key => {
			url += key + "=" + data[key] + "&";
		})

		let headers = {}
		if (this.token) {
			headers['Authorization'] = 'Bearer ' + this.token
		}

		fetch(apiEndpoint + "?" + url, {
			method: 'GET',
			headers: headers
		})
		.then(response => {
			if (response.status == 401) {
				window.location.href = '/'
			}
			return response.json();
		})
		.then((response) => callback(response));
	}
	geocord(apiEndpoint, data, callback) {
		let url = "";
		apiEndpoint = apiEndpoint;

		Object.keys(data).map(key => {
			url += key + "=" + data[key] + "&";
		})


		fetch(apiEndpoint + "?" + url, {
			method: 'GET',
		})
		.then(response => {
			return response.json();
		})
		.then((response) => callback(response));
	}
	arcgis(apiEndpoint, data, callback) {
		let url = "";
		apiEndpoint = apiEndpoint;

		Object.keys(data).map(key => {
			url += key + "=" + data[key] + "&";
		})


		fetch(apiEndpoint + "&" + url, {
			method: 'GET',
		})
		.then(response => {
			return response.json();
		})
		.then((response) => callback(response));
	}
}
